import { History } from "history";

import {
  CreateLectureRequest,
  PaginateQuery,
  UpdateLectureRequest,
  LectureDto,
} from "../../interfaces";
import { Paginated } from "../../models";
import { MediaDto } from "../../interfaces/media";

//#region Get Lectures

export const GET_LECTURES = "GET_LECTURES";
export const GET_LECTURES_SUCCESS: any = "GET_LECTURES_SUCCESS";
export const GET_LECTURES_ERROR: any = "GET_LECTURES_ERROR";

export interface GetLecturesAction {
  type: typeof GET_LECTURES;
  payload: {
    request: PaginateQuery;
    history: History;
  };
}

export interface GetLecturesSuccessAction {
  type: typeof GET_LECTURES_SUCCESS;
  payload: Paginated<LectureDto>;
}

export interface GetLecturesErrorAction {
  type: typeof GET_LECTURES_ERROR;
  payload: any;
}
//#endregion

//#region Get Lectures by Lesson Id

export const GET_LECTURES_BY_LESSON = "GET_LECTURES_BY_LESSON";
export const GET_LECTURES_BY_LESSON_SUCCESS: any =
  "GET_LECTURES_BY_LESSON_SUCCESS";
export const GET_LECTURES_BY_LESSON_ERROR: any = "GET_LECTURES_BY_LESSON_ERROR";

export interface GetLecturesByLessonAction {
  type: typeof GET_LECTURES_BY_LESSON;
  payload: {
    lessonId: string;
    history: History;
  };
}

export interface GetLecturesByLessonSuccessAction {
  type: typeof GET_LECTURES_BY_LESSON_SUCCESS;
  payload: LectureDto[];
}

export interface GetLecturesByLessonErrorAction {
  type: typeof GET_LECTURES_BY_LESSON_ERROR;
  payload: any;
}
//#endregion

//#region Get Lectures by Subject Id

export const GET_LECTURES_BY_SUBJECT = "GET_LECTURES_BY_SUBJECT";
export const GET_LECTURES_BY_SUBJECT_SUCCESS: any =
  "GET_LECTURES_BY_SUBJECT_SUCCESS";
export const GET_LECTURES_BY_SUBJECT_ERROR: any =
  "GET_LECTURES_BY_SUBJECT_ERROR";

export interface GetLecturesBySubjectAction {
  type: typeof GET_LECTURES_BY_SUBJECT;
  payload: {
    subjectId: string;
    history: History;
  };
}

export interface GetLecturesBySubjectSuccessAction {
  type: typeof GET_LECTURES_BY_SUBJECT_SUCCESS;
  payload: LectureDto[];
}

export interface GetLecturesBySubjectErrorAction {
  type: typeof GET_LECTURES_BY_SUBJECT_ERROR;
  payload: any;
}
//#endregion

//#region Get Lecture

export const GET_LECTURE = "GET_LECTURE";
export const GET_LECTURE_SUCCESS: any = "GET_LECTURE_SUCCESS";
export const GET_LECTURE_ERROR: any = "GET_LECTURE_ERROR";

export interface GetLectureAction {
  type: typeof GET_LECTURE;
  payload: {
    id: string;
    history: History;
  };
}

export interface GetLectureSuccessAction {
  type: typeof GET_LECTURE_SUCCESS;
  payload: LectureDto;
}

export interface GetLectureErrorAction {
  type: typeof GET_LECTURE_ERROR;
  payload: any;
}
//#endregion

//#region Add Lecture

export const ADD_LECTURE = "ADD_LECTURE";
export const ADD_LECTURE_SUCCESS: any = "ADD_LECTURE_SUCCESS";
export const ADD_LECTURE_ERROR: any = "ADD_LECTURE_ERROR";

export interface AddLectureAction {
  type: typeof ADD_LECTURE;
  payload: {
    request: CreateLectureRequest;
    history: History;
  };
}

export interface AddLectureSuccessAction {
  type: typeof ADD_LECTURE_SUCCESS;
  payload: LectureDto;
}

export interface AddLectureErrorAction {
  type: typeof ADD_LECTURE_ERROR;
  payload: any;
}
//#endregion

//#region Update Lecture

export const UPDATE_LECTURE = "UPDATE_LECTURE";
export const UPDATE_LECTURE_SUCCESS: any = "UPDATE_LECTURE_SUCCESS";
export const UPDATE_LECTURE_ERROR: any = "UPDATE_LECTURE_ERROR";

export interface UpdateLectureAction {
  type: typeof UPDATE_LECTURE;
  payload: {
    id: string;
    request: UpdateLectureRequest;
    history: History;
  };
}

export interface UpdateLectureSuccessAction {
  type: typeof UPDATE_LECTURE_SUCCESS;
  payload: LectureDto;
}

export interface UpdateLectureErrorAction {
  type: typeof UPDATE_LECTURE_ERROR;
  payload: any;
}
//#endregion

//#region Delete Lecture

export const DELETE_LECTURE_CONSENT: any = "DELETE_LECTURE_CONSENT";
export const DELETE_LECTURE = "DELETE_LECTURE";
export const DELETE_LECTURE_SUCCESS: any = "DELETE_LECTURE_SUCCESS";
export const DELETE_LECTURE_ERROR: any = "DELETE_LECTURE_ERROR";

export interface DeleteLectureConsentAction {
  type: typeof DELETE_LECTURE_CONSENT;
  payload: string;
}

export interface DeleteLectureAction {
  type: typeof DELETE_LECTURE;
  payload: {
    id: string;
    history: History;
  };
}

export interface DeleteLectureSuccessAction {
  type: typeof DELETE_LECTURE_SUCCESS;
  payload: string;
}

export interface DeleteLectureErrorAction {
  type: typeof DELETE_LECTURE_ERROR;
  payload: any;
}
//#endregion

//#region Upload Lecture Video

export const UPLOAD_LECTURE_VIDEO = "UPLOAD_LECTURE_VIDEO";
export const UPLOAD_LECTURE_VIDEO_SUCCESS: any = "UPLOAD_LECTURE_VIDEO_SUCCESS";
export const UPLOAD_LECTURE_VIDEO_ERROR: any = "UPLOAD_LECTURE_VIDEO_ERROR";
export const UPLOAD_LECTURE_VIDEO_PROGRESS: any =
  "UPLOAD_LECTURE_VIDEO_PROGRESS";

export interface UploadLectureVideoAction {
  type: typeof UPLOAD_LECTURE_VIDEO;
  payload: {
    file: File;
    history: History;
    lectureId?: string;
  };
}
export interface UploadLectureVideoSuccessAction {
  type: typeof UPLOAD_LECTURE_VIDEO_SUCCESS;
  payload: MediaDto;
}

export interface UploadLectureVideoErrorAction {
  type: typeof UPLOAD_LECTURE_VIDEO_ERROR;
  payload: any;
}

export interface UploadLectureVideoProgressAction {
  type: typeof UPLOAD_LECTURE_VIDEO_PROGRESS;
  payload: number;
}

//#endregion

//#region add edit lecture modal
export const TOGGLE_ADD_EDIT_LECTURE_MODAL: any =
  "TOGGLE_ADD_EDIT_LECTURE_MODAL";

export interface ToggleAddEditLectureModalAction {
  type: typeof TOGGLE_ADD_EDIT_LECTURE_MODAL;
  payload: any;
}
//#endregion

//#region Toggle Lecture State

export const TOGGLE_LECTURE_STATE_CONSENT: any = "TOGGLE_LECTURE_STATE_CONSENT";
export const TOGGLE_LECTURE_STATE = "TOGGLE_LECTURE_STATE";
export const TOGGLE_LECTURE_STATE_SUCCESS: any = "TOGGLE_LECTURE_STATE_SUCCESS";
export const TOGGLE_LECTURE_STATE_ERROR: any = "TOGGLE_LECTURE_STATE_ERROR";

export interface ToggleLectureStateConsentAction {
  type: typeof TOGGLE_LECTURE_STATE_CONSENT;
  payload: string;
}

export interface ToggleLectureStateAction {
  type: typeof TOGGLE_LECTURE_STATE;
  payload: {
    id: string;
    history: History;
  };
}

export interface ToggleLectureStateSuccessAction {
  type: typeof TOGGLE_LECTURE_STATE_SUCCESS;
  payload: { id: string };
}

export interface ToggleLectureStateErrorAction {
  type: typeof TOGGLE_LECTURE_STATE_ERROR;
  payload: any;
}
//#endregion

// Export a union type that represents all possible actions
export type ActionTypes =
  | GetLecturesAction
  | GetLecturesSuccessAction
  | GetLecturesErrorAction
  | GetLecturesByLessonAction
  | GetLecturesByLessonSuccessAction
  | GetLecturesByLessonErrorAction
  | GetLectureAction
  | GetLectureSuccessAction
  | GetLectureErrorAction
  | AddLectureAction
  | AddLectureSuccessAction
  | AddLectureErrorAction
  | UpdateLectureAction
  | UpdateLectureSuccessAction
  | UpdateLectureErrorAction
  | DeleteLectureConsentAction
  | DeleteLectureAction
  | DeleteLectureSuccessAction
  | DeleteLectureErrorAction
  | UploadLectureVideoAction
  | UploadLectureVideoSuccessAction
  | UploadLectureVideoErrorAction
  | UploadLectureVideoProgressAction;
